<template>
  <div>
    <el-dialog :title="$t('lange.report')" :visible.sync="isShow" width="80%" center :close-on-click-modal="false"
      :show-close="false">
      <div class="text-center">{{$t('lange.explain')}}</div>
      <div class="hrs mt-2"></div>
      <div class="mt-2">{{$t('lange.reptype')}}</div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
        <el-form-item prop="type">
          <el-row class="mt-2">
            <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6" class="flex  align-center justify-center mb-1">
              <el-radio v-model="ruleForm.type" label="盗版">{{$t('lange.pirate')}}
              </el-radio>
            </el-col>
            <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6" class="flex  align-center justify-center mb-1">
              <el-radio v-model="ruleForm.type" label="黄色">{{$t('lange.yellow')}}
              </el-radio>
            </el-col>
            <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6" class="flex  align-center justify-center mb-1">
              <el-radio v-model="ruleForm.type" label="欺诈">{{$t('lange.cheat')}}
              </el-radio>
            </el-col>
            <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6" class="flex  align-center justify-center mb-1">
              <el-radio v-model="ruleForm.type" label="其他">{{$t('lange.other')}}
              </el-radio>
            </el-col>
          </el-row>
        </el-form-item>
        <div>{{$t('lange.Reasons')}}</div>
        <el-form-item prop="desc">
          <el-input type="textarea" v-model="ruleForm.desc" :placeholder="$t('lange.replenish')"></el-input>
        </el-form-item>
        <div>{{$t('lange.email')}}</div>
        <el-form-item prop="email">
          <el-input v-model="ruleForm.email" :placeholder="$t('lange.write')"></el-input>
        </el-form-item>
        <!-- <div>{{$t('lange.phone')}}</div>
        <el-form-item prop="phone">
          <el-input v-model="ruleForm.phone" :placeholder="$t('lange.mobiles')"></el-input>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel()" class="blue_button">{{$t('lange.back')}}</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">{{$t('lange.affirm')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    props: {
      isShow: {
        type: Boolean,
        default: false
      },
      id: {
        type: String
      },
      appName: {
        type: String
      }
    },
    components: {},
    data() {
      return {
        ruleForm: {
          type: '',
          desc: '',
          email: '',
          // phone: '',
        },
        rules: {
          type: [{
            required: true,
            message: this.$t('lange.one'),
            trigger: 'blur'
          }],
          desc: [{
            required: true,
            message: this.$t('lange.two'),
            trigger: 'blur'
          }],
          email: [{
              required: true,
              message: this.$t('lange.three'),
              trigger: 'blur'
            },
            {
              type: 'email',
              message: this.$t('lange.four'),
              trigger: ['blur', 'change']
            }
          ],
          // phone: [{
          //   required: true,
          //   message: this.$t('lange.five'),
          //   trigger: 'blur'
          // }, {
          //   min: 11,
          //   max: 11,
          //   message: this.$t('lange.six'),
          //   trigger: 'blur'
          // }]
        },
      };
    },
    computed: {},
    watch: {},
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            // this.$emit('update:isShow', false)
            // this.isShow=false;
            // console.log(this.ruleForm);
            var params = new URLSearchParams();
            params.append("app_id", this.id);
            params.append("type", this.ruleForm.type);
            params.append("message", this.ruleForm.desc);
            params.append("email", this.ruleForm.email);
            params.append("app_name", this.appName);
            this.$post(this.WindowApi.api + this.API.report, params).then((res) => {
              // console.log(res);
              if (res.code == 200) {
                this.$message.success(res.msg)
                this.$emit('cancel');
              } else {
                this.$message.error(res.msg);
                this.$emit('cancel');
              }
            })
          } else {
            return false;
          }
        });
      },
      cancel() {
        // this.$emit('update:isShow', false)
        this.$emit('cancel')
      },

    },
    created() {
      // console.log(this.id);
    },
    mounted() {

    },
  }

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/disalog.vue